<template>
  <router-view></router-view>
</template>

<script>
/* eslint-disable no-unused-vars */

import RankZoneReport from './rank-zone/index'
import RelevancyReport from './relevancy/RelevancyReport'
import AttributeReport from './attribute/AttributeReport'
/**
   * this component is simple host for {@link RankZoneReport} and {@link RelevancyReport} {@link AttributeReport} components
   */
export default {
  name: 'Reports',
  data () {
    return {
      path: [
        { name: 'Dashboard', link: '/' }
      ]
    }
  },
  watch: {
    // remove filters from url on client change to prevent getting back to saved client on page refresh
    clientId() {
      this.$router.replace({ name: this.$route.name} )
    }
  }
}
</script>

<style scoped lang="scss">

  .reports {
    &__breadcrumb {
      margin: -5px 0 22px;
    }

    &__link {
      display: block;
      font-size: 16px;
      padding: 20px;
      background-color: #fff;
      border-radius: 4px;
      flex: 1 1;
      margin-top: 10px;

      &:first-child {
        margin-top: 0;
      }
    }

    &__link-wrapper {
      display: flex;
      flex-direction: column;
      width: 25vw;
    }
  }

</style>
